export enum From {
    USER = 'user',
    ASSISTANT = 'assistant',
}

export interface KBItem {
    id: string;
    title: string;
    type: string;
}

export interface UserPrompt {
    query: string;
}

export enum ActionTypes {
    SELECT_SECTION = 'selectSection',
    SHOW_ARTICLE = 'showArticle',
    KNOWLEDGE_BASE = 'knowledgeBase',
    EMAIL_OPERATOR = 'emailOperator',
    TELEGRAM_BOT = 'telegramBot',
    CONSULTATIONS = 'consultations',
}

export interface Action {
    type: ActionTypes;
    payload?: string;
}

export interface Message {
    id: number;
    from: From;
    text: string;
    action?: Action;
}

export enum Tabs {
    CHAT = 'chat',
    LANGUAGE = 'language',
    OPERATOR = 'operator',
}

export interface EmailFormData {
    name: string;
    phoneNumber: string;
    email: string;
    content: string;
}
